import { render, staticRenderFns } from "./AutoSuggest.vue?vue&type=template&id=b3f3ea6c"
import script from "./AutoSuggest.vue?vue&type=script&lang=js"
export * from "./AutoSuggest.vue?vue&type=script&lang=js"
import style0 from "./AutoSuggest.vue?vue&type=style&index=0&id=b3f3ea6c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports